import Vue from 'vue'
import Router from 'vue-router'
import Monitor from '@/views/Monitor'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/:id',
      name: 'Monitor',
      component: Monitor
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js